import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { round } from 'lodash';
import { groupByTrackerPrefix } from '../../shared/Helper';
import { useParams } from 'react-router-dom';
import { getCurrentTerms } from '../../shared/projectTypeUtils';

const TrackerType = ({ trackerList, loader, handleClickTracker, trackers, selectedRow }) => {
  const [data, setData] = useState([]);
    const params = useParams();

    const { id } = params;
  const TERMS = getCurrentTerms()

  useEffect(() => {
    setData(groupByTrackerPrefix(trackerList));
  }, [trackerList]);


    const getCounts = (value) => {
      if (!selectedRow?.trackerTypes || !value.children) return 0;
      
      return value.children.reduce((total, child) => {
        const trackerId = child.tracker_type_id;
        const trackerKey = `trackerType_${trackerId}`;
        const count = selectedRow?.trackerTypes?.[trackerKey]?.selectedCount || 0;
        return total + count;
      }, 0);
    }
    
    return (
      <Box py={1}>
        <Card variant="outlined" sx={{ border: '1px solid #e2e8f0', borderRadius: '5px' }}>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center" py={2}>
              <Typography fontSize={18} fontWeight={600}>
                {TERMS.TRACKER_LABEL} Type
              </Typography>
              <Typography fontSize={18} fontWeight={600} color="#f16253">
                Quantities
              </Typography>
            </Box>
  
            {loader ? (
              <Box display="flex" alignItems="center" justifyContent="center" height="200px">
                <CircularProgress />
              </Box>
            ) : (
              <Box>
             

                {data.map((activity, index) => {
                  const children = activity.children || [];

                  if (children.length === 1) {
                    const child = children[0];
                    const childKey = `trackerType_${child?.tracker_type_id}`;
                    const isFullySelected = selectedRow?.trackerTypes?.[childKey]?.selectedCount === round(child.count);

                    return (
                      <Box key={index} mb={1}>
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          px={2}
                          py={0.5}
                          sx={{
                            border: selectedRow?.trackerTypes?.[childKey]?.selectedCount ? '1px solid #f16253' : "1px solid #e2e8f0",
                            borderRadius: '5px',
                            cursor: id ? "pointer" : "not-allowed",
                            '&:hover': { boxShadow: 1 },
                            backgroundColor: isFullySelected ? "#f16253" : '#fff',
                            color: isFullySelected ? "white" : ""
                          }}
                          onClick={() => handleClickTracker("child", child)}
                        >
                          <Typography fontSize={14} color={isFullySelected ? "white" : "#334155"}>
                            {child.tracker_type}
                          </Typography>
                          <Typography fontSize={14} color={isFullySelected ? "white" : "#334155"}>
                            {round(child.count)}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  }

                  return (
                    <Box key={index} mb={1}>
                      {/* Parent */}
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        px={2}
                        py={0.5}
                        sx={{
                          border: '1px solid #e2e8f0',
                          borderRadius: '5px',
                          cursor: id ? "pointer" : "not-allowed",
                          '&:hover': { boxShadow: 2 },
                          backgroundColor: getCounts(activity) === round(activity.count) ? "#f16253" : '#fff',
                          color: getCounts(activity) === round(activity.count) ? "white" : ""
                        }}
                        onClick={() => handleClickTracker("parent", activity)}
                      >
                        <Typography fontSize={14} fontWeight={600}>
                          {activity?.tracker_type}
                        </Typography>
                        <Typography fontSize={14} fontWeight={600} color={getCounts(activity) === round(activity.count) ? "white" : "#f16253"}>
                          {round(activity.count)}
                        </Typography>
                      </Box>

                      {/* Children */}
                      {children.map((child, childIndex) => {
                        const childKey = `trackerType_${child?.tracker_type_id}`;
                        const isFullySelected = selectedRow?.trackerTypes?.[childKey]?.selectedCount === round(child.count);

                        return (
                          <Box
                            key={childIndex}
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            px={2}
                            py={0.5}
                            mt={0.5}
                            sx={{
                              border: selectedRow?.trackerTypes?.[childKey]?.selectedCount ? '1px solid #f16253' : "1px solid #e2e8f0",
                              borderRadius: '5px',
                              cursor: 'pointer',
                              '&:hover': { boxShadow: 1 },
                              backgroundColor: isFullySelected ? "#f16253" : '#fff',
                              color: isFullySelected ? "white" : ""
                            }}
                            onClick={() => handleClickTracker("child", child)}
                          >
                            <Typography fontSize={14} color={isFullySelected ? "white" : "#334155"}>
                              {child.tracker_type}
                            </Typography>
                            <Typography fontSize={14} color={isFullySelected ? "white" : "#334155"}>
                              {round(child.count)}
                            </Typography>
                          </Box>
                        );
                      })}
                    </Box>
                  );
                })}

              </Box>
            )}
          </CardContent>
        </Card>
      </Box>
    );
  };
  
  export default TrackerType;
  